import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  getAllCollections,
  getIsCollectionsDataPending,
} from '../../store/selectors/collections.selectors';

import LoadingContainer from './Loading';
import ErrorBoundary from './ErrorBoundary';
import ProductCollectionContainer from '../shopping/ProductCollection';

import { ProductCollectionDto } from '../../types/schema';
import { default as styles } from '../../scss/pages/_plp.module.scss';
import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

type Collections = ProductCollectionDto[];
const renderCollection = (collections: Collections) => (
  collections?.length
    ? collections.map((collection) => (
      <ProductCollectionContainer
        key={collection.id}
        collection={collection}
      />
    ))
    : null
);

interface PageCollectionsProps {
  error?: string;
}

const PageCollections = ({ error }: PageCollectionsProps) => {
  const pageCollections: Collections = useSelector(getAllCollections);
  const isPageCollectionsDataPending: boolean = useSelector(
    getIsCollectionsDataPending,
  );

  if (error) {
    return (
      <div className={withCssModulesClassNamesHandler('plp-error-boundary')}>
        <ErrorBoundary
          error={new Error(error)}
          errorMessage="Failed to load collections"
        />
      </div>
    );
  }

  if (isPageCollectionsDataPending) {
    return <LoadingContainer />;
  }

  return (
    <div className={withCssModulesClassNamesHandler('plp')} id="all">
      {renderCollection(pageCollections)}
    </div>
  );
};

PageCollections.defaultProps = {
  error: undefined,
};

PageCollections.propTypes = {
  error: PropTypes.string,
};

interface ProductCollectionsProps extends PageCollectionsProps {
  collections: Collections;
}
const ProductCollections = ({
  error,
  collections,
}: ProductCollectionsProps) => (
  renderCollection(collections) ?? <PageCollections error={error} />
);

ProductCollections.defaultProps = {
  error: undefined,
};

ProductCollections.propTypes = {
  ...PageCollections.propTypes,
  collections: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ProductCollections;
